import React from 'react';
import { FiCalendar, FiCheck, FiSlash, FiUserX } from 'react-icons/fi';

// Colour and icon per status. Status is never conveyed by colour alone — the
// label and icon carry it too, so it survives greyscale and colour blindness.
const STATUS_META = {
  scheduled: { label: 'Scheduled', Icon: FiCalendar },
  completed: { label: 'Completed', Icon: FiCheck },
  cancelled: { label: 'Cancelled', Icon: FiSlash },
  'no-show': { label: 'No-show', Icon: FiUserX },
};

export default function StatusBadge({ status, size = 'md' }) {
  const meta = STATUS_META[status] ?? { label: status, Icon: FiCalendar };
  const { label, Icon } = meta;

  return (
    <span className={`mm-status mm-status--${status} mm-status--${size}`}>
      <Icon size={size === 'sm' ? 11 : 12} aria-hidden="true" />
      {label}
    </span>
  );
}

export { STATUS_META };
